import { PatientDocument } from 'common/enum/patient-document'

export const surgicalOrderGuideDocumentsTypes = [
  {
    value: 'hospitalization-request-guide',
    type: PatientDocument.GUIDE_HOSPITALIZATION_REQUEST
  },
  {
    value: 'surgical-planning-guide',
    type: PatientDocument.GUIDE_SURGICAL_PLANNING
  },
  {
    value: 'opme-guide',
    type: PatientDocument.GUIDE_OPME
  },
  {
    value: 'surgical-order-guide',
    type: PatientDocument.GUIDE_SURGICAL_ORDER
  },
  {
    value: 'sp-sadt-guide',
    type: PatientDocument.GUIDE_SPSADT
  }
]

export const getSurgicalOrderGuideDocumentType = (type: string) => {
  const guideDocumentType = surgicalOrderGuideDocumentsTypes.find(
    (e) => e.value === type
  )
  return guideDocumentType ? guideDocumentType.type : ''
}
